<script>
export default {
    name: 'IconArrowheadTop'
}
</script>
<template>
    <svg
        class="base-icon icon-arrowhead-top"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M8 41.8L31.9 18l.099.1.1-.1L56 41.8 51.782 46 32 26.301 12.218 46z"
            fill-rule="evenodd"
        />
    </svg>
</template>
